import { render, staticRenderFns } from "./TitleJumbotron.vue?vue&type=template&id=b2f41ec6&"
import script from "./TitleJumbotron.vue?vue&type=script&lang=js&"
export * from "./TitleJumbotron.vue?vue&type=script&lang=js&"
import style0 from "./TitleJumbotron.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports